// extracted by mini-css-extract-plugin
export default {"root":"Switch_root__fQHOp","reverse":"Switch_reverse__N4B0p","label":"Switch_label__8klAD"};